import emailValidation from './emailValidation';
import phoneProTechValidation from './phoneProTechValidation';
import phoneValidation from './phoneValidation';

const errorCatch = (panel, data) => {
  const errorObj = {};
  switch (panel) {
    case 'login': {
      const { email, password } = data;
      if (!email) {
        errorObj.emailErr = 'Please enter email.';
      } else if (!emailValidation(email)) {
        errorObj.emailErr = 'Email is not a valid address.';
      }
      if (!password) {
        errorObj.passwordErr = 'Please enter password.';
      }
      break;
    }
    case 'newPartner': {
      const {
        corporationName,
        billSameAsPrimary,
        hscompanyId,
        address: {
          email,
          phone,
        },
        billingAddress: {
          email: bEmail,
          phone: bPhone,
        },
      } = data;
      if (!corporationName) {
        errorObj.corporationNameErr = 'Company name is required.';
      }
      if (email && !emailValidation(email)) {
        errorObj.emailErr = 'Email is not a valid address.';
      }
      if (phone && !phoneValidation(phone)) {
        errorObj.phoneErr = 'Phone is not a valid number.';
      }
      if (!billSameAsPrimary) {
        if (bEmail && !emailValidation(bEmail)) {
          errorObj.bEmailErr = 'Email is not a valid address.';
        }
        if (bPhone && !phoneValidation(bPhone)) {
          errorObj.bPhoneErr = 'Phone is not a valid number.';
        }
      }
      if (!hscompanyId) {
        errorObj.hscompanyId = 'Hubspot Company id is required.';
      }

      break;
    }
    case 'newProduct': {
      const {
        catalogType,
        type,
        itemClass,
        category,
        skuCode,
        internalName,
        externalName,
        description,
        salePrice,
        listPrice,
        merv,
        thickness,
        packSize,
        vendorMultiple,
        vendor,
        imageUrl,
        taxCode,
        accountingItemCode,
        accountName,
        accountClass,
        itemId,
        priceId,
      } = data;
      if (!imageUrl) {
        errorObj.productImageURLErr = 'Image Icon URL is required.';
      }
      if (!skuCode) {
        errorObj.productSkuErr = 'SKU is required.';
      }
      if (!catalogType) {
        errorObj.productCatalogTypeErr = 'Catalog Type is required.';
      }
      if (!internalName) {
        errorObj.productInternalNameErr = 'Internal Name is required.';
      }
      if (!type) {
        errorObj.productTypeErr = 'Type is required.';
      }
      if (!category) {
        errorObj.productCategoryErr = 'Category is required.';
      }
      if (!itemClass) {
        errorObj.productItemClassErr = 'Item class is required.';
      }
      if (!externalName) {
        errorObj.productExternalNameErr = 'External Name is required.';
      }
      if (!description) {
        errorObj.productDescriptionErr = 'description is required.';
      }
      if (!salePrice) {
        errorObj.productSalePriceErr = 'Sale price is required.';
      }
      if (!listPrice) {
        errorObj.productListPriceErr = 'List price is required.';
      }
      if (!packSize) {
        errorObj.productPackSizeErr = 'Pack size is required.';
      }
      if (!vendorMultiple) {
        errorObj.productVendorMultipleErr = 'Vendor multiple is required.';
      }
      if (!vendor) {
        errorObj.productVendorErr = 'Vendor is required.';
      }
      if (!taxCode) {
        errorObj.productTaxCodeErr = 'Tax code is required.';
      }
      if (!accountingItemCode) {
        errorObj.productAccountingItemCodeErr = 'Accounting Item code is required.';
      }
      if (!accountName) {
        errorObj.productAccountNameErr = 'Account name is required.';
      }
      if (!accountClass) {
        errorObj.productAccountClassErr = 'Account class is required.';
      }
      if (!itemId) {
        errorObj.productItemIdErr = 'Item ID is required.';
      }
      if (!priceId) {
        errorObj.productPriceIdErr = 'Price ID is required.';
      }
      if (type && type === 'Filter' && !merv) {
        errorObj.productMervErr = 'Merv is required.';
      }
      if (type && type === 'Filter' && !thickness) {
        errorObj.productThicknessErr = 'Thickness is required.';
      }
      break;
    }
    case 'updateProduct': {
      const {
        catalogType,
        type,
        itemClass,
        category,
        skuCode,
        internalName,
        externalName,
        description,
        salePrice,
        listPrice,
        merv,
        thickness,
        packSize,
        vendorMultiple,
        vendor,
        imageUrl,
        taxCode,
        accountingItemCode,
        accountName,
        accountClass,
        itemId,
        priceId,
      } = data;
      if (!imageUrl) {
        errorObj.productImageURLErr = 'Image Icon URL is required.';
      }
      if (!skuCode) {
        errorObj.productSkuErr = 'SKU is required.';
      }
      if (!catalogType) {
        errorObj.productCatalogTypeErr = 'Catalog Type is required.';
      }
      if (!internalName) {
        errorObj.productInternalNameErr = 'Internal Name is required.';
      }
      if (!type) {
        errorObj.productTypeErr = 'Type is required.';
      }
      if (!category) {
        errorObj.productCategoryErr = 'Category is required.';
      }
      if (!itemClass) {
        errorObj.productItemClassErr = 'Item class is required.';
      }
      if (!externalName) {
        errorObj.productExternalNameErr = 'External Name is required.';
      }
      if (!description) {
        errorObj.productDescriptionErr = 'description is required.';
      }
      if (!salePrice) {
        errorObj.productSalePriceErr = 'Sale price is required.';
      }
      if (!listPrice) {
        errorObj.productListPriceErr = 'List price is required.';
      }
      if (!packSize) {
        errorObj.productPackSizeErr = 'Pack size is required.';
      }
      if (!vendorMultiple) {
        errorObj.productVendorMultipleErr = 'Vendor multiple is required.';
      }
      if (!vendor) {
        errorObj.productVendorErr = 'Vendor is required.';
      }
      if (!taxCode) {
        errorObj.productTaxCodeErr = 'Tax code is required.';
      }
      if (!accountingItemCode) {
        errorObj.productAccountingItemCodeErr = 'Accounting Item code is required.';
      }
      if (!accountName) {
        errorObj.productAccountNameErr = 'Account name is required.';
      }
      if (!accountClass) {
        errorObj.productAccountClassErr = 'Account class is required.';
      }
      if (!itemId) {
        errorObj.productItemIdErr = 'Item ID is required.';
      }
      if (!priceId) {
        errorObj.productPriceIdErr = 'Price ID is required.';
      }
      if (type && type === 'Filter' && !merv) {
        errorObj.productMervErr = 'Merv is required.';
      }
      if (type && type === 'Filter' && !thickness) {
        errorObj.productThicknessErr = 'Thickness is required.';
      }
      break;
    }
    case 'partnerDevices': {
      const {
        shipment,
      } = data;

      shipment.forEach((s, idx) => {
        if (!s.addressIdx) {
          errorObj[`shipmentAddress${idx}Err`] = 'Please select address.';
        }
        if (!s.quantity || s.quantity === 0) {
          errorObj[`shipmentQuantity${idx}Err`] = 'Please enter quantity.';
        }
      });

      break;
    }
    case 'reset': {
      const {
        password,
        confirmPassword,
      } = data;
      if (!password) {
        errorObj.passwordErr = 'Please enter new password.';
      }
      if (!confirmPassword) {
        errorObj.confirmPasswordErr = 'Please confirm your new password.';
      } else if (password !== confirmPassword) {
        errorObj.confirmPasswordErr = 'Password does not match.';
      }
      break;
    }
    case 'fulfill': {
      const {
        orderType,
        newOrderLineItem,
        partnerDevices,
        shippingMethod,
        shippingOption,
        trackingNumber,
        newOrderLine,
      } = data;

      if (orderType === 'partner') {
        if (shippingMethod === 'shipment') {
          if (!newOrderLineItem.shippingOption) {
            errorObj.shippingOptionErr = 'Please select shipping option.';
          }
          if (!newOrderLineItem.trackingNumber) {
            errorObj.trackingNumberErr = 'Please enter tracking number.';
          }
        }
        if (newOrderLineItem.itemName.includes('Base Kit')) {
          partnerDevices.forEach((d, idx) => {
            if (!d.uid) {
              errorObj[`device${idx}Err`] = 'Serial number is required.';
            } else if (!d.uid.includes('SMARTACHUB1')) {
              errorObj[`device${idx}Err`] = 'Serial number is not valid.';
            }
          });
        }
      } else if (orderType === 'customer') {
        if (shippingMethod === 'shipment') {
          if (!shippingOption) {
            errorObj.shippingOptionErr = 'Please select shipping option.';
          }
          if (!trackingNumber) {
            errorObj.trackingNumberErr = 'Please enter tracking number.';
          }
        }
        let totalSelected = 0;
        newOrderLine.forEach((o) => {
          if (o.selected) {
            totalSelected += 1;
          }
        });
        if (totalSelected === 0) {
          errorObj.orderLineErr = 'Please selected at least one item.';
        }
      }
      break;
    }
    case 'newPartnerOrder': {
      const {
        shipment,
      } = data;
      shipment.forEach((s, idx) => {
        if (s.addressIdx === '') {
          errorObj[`shipmentAddress${idx}Err`] = 'Please select address.';
        }
        if (!s.sku) {
          errorObj[`shipmentSku${idx}Err`] = 'Please select product.';
        }
        if (!s.quantity || s.quantity === 0) {
          errorObj[`shipmentQuantity${idx}Err`] = 'Please enter quantity.';
        }
      });
      break;
    }
    case 'manufactureInventory': {
      const {
        uId,
        mac,
      } = data;
      if (!uId) {
        errorObj.uidErr = 'Please enter serial number.';
      } else if (uId.length !== 20) {
        errorObj.uidErr = 'Serial number needs to be 20 characters.';
      } else if (!uId.includes('SMARTACHUB1')) {
        errorObj.uidErr = 'Serial number is not valid.';
      }
      const numbers = Number(uId.slice(14));
      if (Number.isNaN(numbers)) {
        errorObj.uidErr = 'Serial number is not valid.';
      } else if (uId.includes('1A') && (numbers === 0 || numbers < 3072)) {
        errorObj.uidErr = 'Serial number is already reserved.';
      }
      if (!mac) {
        errorObj.uidErr = 'MAC Address is required.';
      } else if (mac.length !== 12) {
        errorObj.uidErr = 'MAC Address needs to be 12 characters.';
      }
      break;
    }
    case 'updateContactInfo': {
      const {
        firstName,
        lastName,
        phone,
        email,
      } = data;

      if (!firstName) {
        errorObj.firstNameErr = 'First name is required.';
      }
      if (!lastName) {
        errorObj.lastNameErr = 'Last name is required.';
      }
      if (phone && !phoneValidation(phone)) {
        errorObj.phoneErr = 'Phone number is not valid.';
      }
      if (!email) {
        errorObj.emailErr = 'Email is required.';
      } else if (!emailValidation(email)) {
        errorObj.emailErr = 'Email is not valid.';
      }

      break;
    }
    case 'qaCheck': {
      const {
        uId,
        checkUid,
        checkFirmware,
        activeTab,
      } = data;

      if (!uId) {
        errorObj.uidErr = 'Please enter serial number.';
      }
      if (activeTab === 'bundle') {
        if (!checkUid) {
          errorObj.checkUidErr = 'Please enter serial number.';
        }
        if (!checkFirmware) {
          errorObj.checkFirmwareErr = 'Please enter firmware.';
        }
      }
      break;
    }
    case 'snoozeAlert': {
      const {
        reason,
        note,
        snoozeDay,
        customSnoozeDay,
      } = data;
      if (!reason) {
        errorObj.actionReasonErr = 'Reason is required.';
      } else if (reason === 'other' && !note) {
        errorObj.actionNoteErr = 'Note is required.';
      }
      if (!snoozeDay) {
        errorObj.snoozeDayErr = 'Snooze days are required.';
      } else if (snoozeDay === 'custom' && !customSnoozeDay) {
        errorObj.snoozeDayErr = 'Please enter custom day.';
      } else if (snoozeDay === 'custom' && !Number(customSnoozeDay)) {
        errorObj.snoozeDayErr = 'Please enter valid number.';
      }
      break;
    }
    case 'serviceAlert': {
      const {
        technicianName,
        workPerformed,
        resolveDate,
      } = data;
      if (!technicianName) {
        errorObj.technicianNameErr = 'Technician name is required.';
      }
      if (!workPerformed) {
        errorObj.workPerformedErr = 'Please enter what work was performed.';
      }
      if (!resolveDate) {
        errorObj.resolveDateErr = 'Date is required.';
      }
      break;
    }
    case 'dismissAlert': {
      const {
        reason,
      } = data;
      if (!reason) {
        errorObj.actionReasonErr = 'Reason is required.';
      }
      break;
    }
    case 'scheduleLead': {
      const {
        scheduleDate,
      } = data;
      if (!scheduleDate) {
        errorObj.scheduleDateErr = 'Date is required.';
      }
      break;
    }
    case 'newAdmin': {
      const {
        email,
        password,
      } = data;
      if (!email) {
        errorObj.adminEmailErr = 'Email is required.';
      } else if (!emailValidation(email)) {
        errorObj.adminEmailErr = 'Email is not valid.';
      }
      if (!password) {
        errorObj.adminPasswordErr = 'Password is required.';
      }
      break;
    }
    // New user and new Admin are same - need to unify on partner details page
    case 'newUser': {
      const {
        firstName,
        lastName,
        email,
      } = data;
      if (email && !emailValidation(email)) {
        errorObj.userEmailErr = 'Email is not valid.';
      }
      if (!firstName) {
        errorObj.userFirstNameErr = 'First name is required.';
      }
      if (!lastName) {
        errorObj.userLastNameErr = 'Last name is required.';
      }
      break;
    }
    case 'newTechnician': {
      const {
        id,
        firstName,
        lastName,
        email,
        phone,
      } = data;

      if (!id && !email) {
        errorObj.techEmailErr = 'Email is required.';
      } else if (email && !emailValidation(email)) {
        errorObj.techEmailErr = 'Email is not valid.';
      }
      if (!firstName) {
        errorObj.techFirstNameErr = 'First name is required.';
      }
      if (!lastName) {
        errorObj.techLastNameErr = 'Last name is required.';
      }
      if (phone && !phoneProTechValidation(phone)) {
        errorObj.techPhoneErr = 'Phone number is not valid.';
      }
      break;
    }
    case 'shippingAddress': {
      const {
        firstName,
        lastName,
        address1,
        city,
        state,
        zip,
        email,
      } = data;
      if (!firstName) {
        errorObj.firstNameErr = 'First name is required.';
      }
      if (!lastName) {
        errorObj.lastNameErr = 'Last name is required.';
      }
      if (!address1) {
        errorObj.address1Err = 'Address is required.';
      }
      if (!city) {
        errorObj.cityErr = 'City is required.';
      }
      if (!state) {
        errorObj.stateErr = 'State is required.';
      }
      if (!zip) {
        errorObj.zipErr = 'Zip is required.';
      }
      if (email && !emailValidation(email)) {
        errorObj.emailErr = 'Email is not a valid address.';
      }
      break;
    }
    case 'hvacProfile': {
      const {
        serialNumber,
        type,
        manufacturer,
        model,
        mfgDate,
        seer,
        speed,
        tonnage,
        refrigerant,
      } = data;
      if (!serialNumber) {
        errorObj.snError = 'Serial Number is required.';
      }
      if (!type) {
        errorObj.typeError = 'Type is required.';
      }
      if (!manufacturer) {
        errorObj.manufacturerError = 'Manufacturer is required.';
      }
      if (!model) {
        errorObj.modelError = 'Model is required.';
      }
      if (!mfgDate) {
        errorObj.mfgDateError = 'MfgDate is required.';
      }
      if (!seer) {
        errorObj.seerError = 'Seer is required.';
      }
      if (!tonnage) {
        errorObj.tonnageError = 'Tonnage is required.';
      }
      if (!speed) {
        errorObj.speedError = 'Speed is required.';
      }
      if (!refrigerant) {
        errorObj.refrigerantError = 'Refrigerant is required.';
      }
      break;
    }
    default:
      break;
  }

  return errorObj;
};

export default errorCatch;
